<template>
  <b-row class="justify-content-center">
    <b-col
      md="8"
      lg="6"
    >
      <b-card class="text-center membership-locked">
        <div class="locked-icon mb-1">
          <feather-icon
            icon="LockIcon"
            size="32"
          />
        </div>

        <h3 class="font-weight-bolder mb-50">
          {{ featureName }}
        </h3>

        <p class="text-muted mb-2">
          {{ message }}
        </p>

        <b-button
          variant="primary"
          :to="{ name: 'membership', query: { upgrade: featureKey } }"
        >
          Ver planes y contratar
        </b-button>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import { featuresOf } from '@/utils/membership'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
  },

  props: {
    featureKey: {
      type: String,
      required: true,
    },
    // 'feature' cuando el plan no incluye la pantalla, 'limit' cuando si la incluye pero
    // el cliente ya se acabo su cupo.
    kind: {
      type: String,
      default: 'feature',
    },
  },

  computed: {
    ...mapGetters('memberships', {
      plans: 'membershipPlans',
      catalog: 'membershipCatalog',
      membership: 'currentMembership',
    }),

    // El nombre y la unidad salen del catálogo del backend para no repetir aquí las
    // etiquetas de cada llave.
    feature() {
      return this.catalog
        .reduce((acc, category) => acc.concat(category.features), [])
        .find(item => item.key === this.featureKey)
    },

    featureName() {
      return this.feature ? this.feature.name : 'Esta sección'
    },

    currentPlanName() {
      return this.membership?.plan_name || 'gratuito'
    },

    paidPlanName() {
      const paid = this.plans.find(plan => plan.purchasable)
      return paid ? paid.name : 'de paga'
    },

    message() {
      if (this.kind === 'limit') {
        const limit = Number(featuresOf(this.membership)[this.featureKey])
        // Un limite de uno no lleva el sustantivo en plural.
        const unit = (limit === 1 ? this.feature?.unit_singular : this.feature?.unit) || 'elementos'
        const already = limit === 1 ? 'ya lo estás usando' : 'ya los estás usando'

        return `Tu plan ${this.currentPlanName} incluye hasta ${limit} ${unit} y ${already}. `
          + `Contrata el plan ${this.paidPlanName} para seguir agregando.`
      }

      return `Esta sección es parte del plan ${this.paidPlanName}. `
        + `Hoy estás en el plan ${this.currentPlanName}, así que todavía no está disponible para tu cuenta.`
    },
  },

  created() {
    if (!this.catalog.length) this.getMembershipPlans()
  },

  methods: {
    ...mapActions('memberships', ['getMembershipPlans']),
  },
}
</script>

<style lang="scss" scoped>
.membership-locked {
  margin-top: 3rem;
}

.locked-icon {
  color: var(--primary);
}
</style>
